import type React from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import LoaderGradient, {
    LOADER_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

export const GeoBreakdownLoader: React.FC = () => {
    return (
        <Box padding="32px">
            <PixelPlaceholderLoader
                width="100%"
                height={268}
                id={LOADER_GRADIENT_ID}
                ShapeMarkup={LoaderGradient}
            />
        </Box>
    );
};
